import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { ProgressInsightsHub } from '../components/ai/ProgressInsightsHub';
import { useProgressInsights } from '../hooks/useProgressInsights';
import { useAppSelector } from '../store';
import { selectUserProfile } from '../store/slices/userSlice';

export function ProgressInsightsScreen() {
  const theme = useTheme();
  const user = useAppSelector(selectUserProfile);

  const { masteryStates, handlers } = useProgressInsights(
    user?.id || 'demo_user'
  );

  return (
    <View
      style={[styles.container, { backgroundColor: theme.colors.background }]}
    >
      <ProgressInsightsHub
        masteryStates={masteryStates}
        userId={user?.id || 'demo_user'}
        onInsightAction={handlers.onInsightAction}
        onSkillFocus={handlers.onSkillFocus}
        onRecommendationSelect={handlers.onRecommendationSelect}
        onShareProgress={handlers.onShareProgress}
        style={styles.hub}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  hub: {
    flex: 1,
    margin: 0, // Override default margin since we're full screen
  },
});
